<template>
  <div>
    <div v-for="kind in kindMaster" :key="kind.kind_id">
      <v-subheader v-text="kind.kind_name" />
      <v-layout row wrap>
        <v-flex xs12 sm6 md4 lg 3 xl2
                v-for="product in productMaster" :key="product.product_id"
                v-if="product.kind_id === kind.kind_id">
          <v-checkbox :label="product.product_name"
                      v-model="product.selected"
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import BaseComponent from '@/components/BaseComponent'

export default {
  name: 'ProductSelect',
  extends: BaseComponent,
  data () {
    return {
      kindMaster: [],
      productMaster: []
    }
  },
  computed: {
    selectedProductIds () {
      let ids = []
      if (!this.productMaster) return ids

      for (let product of this.productMaster) {
        if (product.selected) {
          ids.push(product.product_id)
        }
      }
      return ids
    }
  },
  created () {
    this.loadMaster()
  },
  methods: {
    loadMaster () {
      this.api.getMasterRecords('product-kind').then(resKind => {
        this.kindMaster = resKind.data

        this.api.getMasterRecords('product').then(resProduct => {
          // チェックボックス用のboolean値を追加
          let products = resProduct.data
          for (let product of products) {
            product.selected = false
          }

          this.productMaster = products
          this.$emit('load-master')
        })
        .catch(err => {
          this.handleError('製品マスタの取得に失敗しました。', err)
        })
      })
      .catch(err => {
        this.handleError('機種マスタの取得に失敗しました。', err)
      })
    },
    // 各製品の選択状態設定
    setSelectedIds (selectedIds) {
      if (!this.productMaster) return

      for (let product of this.productMaster) {
        product.selected = (selectedIds.indexOf(product.product_id) !== -1)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductSelect.vue?0df6d29f